<template>
  <div class="page page-single">
    <HeaderSlide />
    <div class="page-container">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">首頁</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/opendata' }">政府網站資料開放宣告</el-breadcrumb-item>
      </el-breadcrumb>
      <article>
        <div class="page-title">
          政府網站資料開放宣告 <a accesskey="C" href="#content" title="content" class="accesskey-content" >:::</a>
        </div>
        <section>
          <h2>一、授權方式及範圍</h2>
          <p>
            為利各界廣為利用網站資料，林務局全球資訊網上刊載之所有資料與素材，其得受著作權保護之範圍，以無償、非專屬，得再授權之方式提供公眾使用，使用者得不限時間及地域，重製、改作、編輯、公開傳輸或為其他方式之利用，開發各種產品或服務（簡稱加值衍生物），此一授權行為不會嗣後撤回，使用者亦無須取得本機關之書面或其他方式授權；然使用時，應註明出處。
          </p>
          <h2>二、相關事項說明：</h2>
          <p>
            (一)本授權範圍僅及於著作權保護之範圍，不及於其他智慧財產權利，包括但不限於專利、商標、及機關標誌之提供。<br>
            (二)當事人自行公開或依法令公開之個人資料是否得被蒐集、處理及利用，使用者須自行依照個人資料保護法之相關規定，規劃並執行法律要求之相應措施。<br>
            (三)部分的影音、圖像、樂譜、專人專案撰文或其他著作，經機關特別聲明須經同意方可使用者。<br>
          </p>
          <h2>三、應注意不得侵害第三人之著作人格權(包括姓名表示權及禁止不當變更權)。</h2>
          <p></p>
          <h2>四、使用本授權提供之資料與素材，不得惡意變更其相關資訊，若利用後所展示之資訊與原資料與素材不符，使用者須自負民事、刑事上之法律責任。</h2>
          <p></p>
          <h2>五、本網站之授權，並不授予使用者代表本機關建議、認可或贊同其加值衍生物之地位。</h2>
          <p></p>
        </section>        
      </article>
    </div>
  </div>
</template>

<script>
  import HeaderSlide from '@/components/frontstage/HeaderSlide.vue';
  import api from '@/api/frontstage'

  import {
    Hooper,
    Slide,
    Navigation as HooperNavigation,
    Pagination as HooperPagination
  } from 'hooper';
  import 'hooper/dist/hooper.css';
  export default {
    name: 'news',
    components: {
      HeaderSlide,
      Hooper,
      Slide,
      HooperNavigation,
      HooperPagination
    },
    async created () {
        if (typeof this.$route.params === 'undefined' || typeof this.$route.params.id === 'undefined') {
          return
        }

        let res = await api.get_latest_news(this.$route.params.id)
        if (res.success) {
            console.log('[前臺] news: ', res)
            this.news = res['payload']['payload']
        }
        else {
            this.notify_message(this.ERROR.LEVEL.ERROR, '無法取得文章', res.message)
            return
        }
    },
    data() {
      return {
        APP: process.env.VUE_APP_URL,
        hooperAttachImageSettings: {
          autoPlay: false,
          playSpeed: 5000,
          transition: 1000,
          infiniteScroll: false,
          wheelControl: false,
          itemsToShow: 3,
          itemsToSlide: 3,
        },
        news: {}
      }
    }
  }
</script>
<style>
  .accesskey-content{
    color: white;
  }
</style>